import { lazy } from 'react';

const svgIconMap = {
    'add-circle': lazy(() => import('./AddCircle')),
    add: lazy(() => import('./Add')),
    alarm: lazy(() => import('./Alarm')),
    alert: lazy(() => import('./Alert')),
    'ambulance-left': lazy(() => import('./AmbulanceLeft')),
    'ambulance-right': lazy(() => import('./AmbulanceRight')),
    'analytics-bars': lazy(() => import('./AnalyticsBars')),
    'analytics-graph': lazy(() => import('./AnalyticsGraph')),
    apple: lazy(() => import('./Apple')),
    area: lazy(() => import('./Area')),
    'arrow-down-left': lazy(() => import('./ArrowDownLeft')),
    'arrow-down-right': lazy(() => import('./ArrowDownRight')),
    'arrow-down': lazy(() => import('./ArrowDown')),
    'arrow-left': lazy(() => import('./ArrowLeft')),
    'arrow-right': lazy(() => import('./ArrowRight')),
    'arrow-up-left': lazy(() => import('./ArrowUpLeft')),
    'arrow-up-right': lazy(() => import('./ArrowUpRight')),
    'arrow-up': lazy(() => import('./ArrowUp')),
    autocamper: lazy(() => import('./Autocamper')),
    basket: lazy(() => import('./Basket')),
    biking: lazy(() => import('./Biking')),
    'blood-test': lazy(() => import('./BloodTest')),
    'blue-lights-truck': lazy(() => import('./BlueLightsTruck')),
    bookshelf: lazy(() => import('./Bookshelf')),
    'broken-windshield': lazy(() => import('./BrokenWindshield')),
    building: lazy(() => import('./Building')),
    'burger-menu': lazy(() => import('./BurgerMenu')),
    'business-travel': lazy(() => import('./BusinessTravel')),
    'calendar-check': lazy(() => import('./CalendarCheck')),
    calendar: lazy(() => import('./Calendar')),
    'call-in-time': lazy(() => import('./CallInTime')),
    'camping-trailer': lazy(() => import('./CampingTrailer')),
    'car-check': lazy(() => import('./CarCheck')),
    'car-checkmark': lazy(() => import('./CarCheckmark')),
    'car-engine-repair': lazy(() => import('./CarEngineRepair')),
    'car-plus-6-meters': lazy(() => import('./CarPlus6Meters')),
    'car-plus': lazy(() => import('./CarPlus')),
    'car-repair': lazy(() => import('./CarRepair')),
    'car-signal': lazy(() => import('./CarSignal')),
    'car-warning-sign': lazy(() => import('./CarWarningSign')),
    'car-wash-2': lazy(() => import('./CarWash2')),
    'car-wash': lazy(() => import('./CarWash')),
    'car-wheel': lazy(() => import('./CarWheel')),
    car: lazy(() => import('./Car')),
    'caret-down-padding': lazy(() => import('./CaretDownPadding')),
    'caret-down': lazy(() => import('./CaretDown')),
    'caret-left-padding': lazy(() => import('./CaretLeftPadding')),
    'caret-left': lazy(() => import('./CaretLeft')),
    'caret-right-padding': lazy(() => import('./CaretRightPadding')),
    'caret-right': lazy(() => import('./CaretRight')),
    'caret-up-padding': lazy(() => import('./CaretUpPadding')),
    'caret-up': lazy(() => import('./CaretUp')),
    cart: lazy(() => import('./Cart')),
    chat: lazy(() => import('./Chat')),
    'check-badge': lazy(() => import('./CheckBadge')),
    'check-circle': lazy(() => import('./CheckCircle')),
    checkbox: lazy(() => import('./Checkbox')),
    'circle-checkmark': lazy(() => import('./CircleCheckmark')),
    'circle-close-bold': lazy(() => import('./CircleCloseBold')),
    'circle-close-light': lazy(() => import('./CircleCloseLight')),
    'circle-error': lazy(() => import('./CircleError')),
    'circle-info': lazy(() => import('./CircleInfo')),
    'circle-pending': lazy(() => import('./CirclePending')),
    circle: lazy(() => import('./Circle')),
    'clock-checkmark': lazy(() => import('./ClockCheckmark')),
    clock: lazy(() => import('./Clock')),
    'close-padding': lazy(() => import('./ClosePadding')),
    close: lazy(() => import('./Close')),
    'connect-devices': lazy(() => import('./ConnectDevices')),
    'construction-building': lazy(() => import('./ConstructionBuilding')),
    crashed: lazy(() => import('./Crashed')),
    'credit-card': lazy(() => import('./CreditCard')),
    'customer-support': lazy(() => import('./CustomerSupport')),
    'defibrilator-cabinet': lazy(() => import('./DefibrilatorCabinet')),
    defibrilator: lazy(() => import('./Defibrilator')),
    desktop: lazy(() => import('./Desktop')),
    'diet-scale': lazy(() => import('./DietScale')),
    disabled: lazy(() => import('./Disabled')),
    'document-check': lazy(() => import('./DocumentCheck')),
    door: lazy(() => import('./Door')),
    'edit-draft': lazy(() => import('./EditDraft')),
    'edit-profile-1': lazy(() => import('./EditProfile1')),
    'edit-profile-2': lazy(() => import('./EditProfile2')),
    edit: lazy(() => import('./Edit')),
    'envelope-closed': lazy(() => import('./EnvelopeClosed')),
    'envelope-opened': lazy(() => import('./EnvelopeOpened')),
    experience: lazy(() => import('./Experience')),
    'external-app': lazy(() => import('./ExternalApp')),
    'facebook-1': lazy(() => import('./Facebook1')),
    'facebook-2': lazy(() => import('./Facebook2')),
    'family-home': lazy(() => import('./FamilyHome')),
    family: lazy(() => import('./Family')),
    figma: lazy(() => import('./Figma')),
    'fire-alarm': lazy(() => import('./FireAlarm')),
    'fire-exit-stairs': lazy(() => import('./FireExitStairs')),
    'fire-extinguisher': lazy(() => import('./FireExtinguisher')),
    'fire-hydrant-1': lazy(() => import('./FireHydrant1')),
    'fire-hydrant-2': lazy(() => import('./FireHydrant2')),
    'fire-man': lazy(() => import('./FireMan')),
    'firefighter-truck': lazy(() => import('./FirefighterTruck')),
    'first-aid-kit-2': lazy(() => import('./FirstAidKit2')),
    'first-aid-kit': lazy(() => import('./FirstAidKit')),
    'first-aid': lazy(() => import('./FirstAid')),
    'first-invoice': lazy(() => import('./FirstInvoice')),
    'folder-bookmark': lazy(() => import('./FolderBookmark')),
    'football-player': lazy(() => import('./FootballPlayer')),
    'forklift-truck': lazy(() => import('./ForkliftTruck')),
    'gift-hands': lazy(() => import('./GiftHands')),
    'give-gift': lazy(() => import('./GiveGift')),
    'global-assistance': lazy(() => import('./GlobalAssistance')),
    'globe-plane': lazy(() => import('./GlobePlane')),
    globe: lazy(() => import('./Globe')),
    'globepin-1': lazy(() => import('./Globepin1')),
    'globepin-2': lazy(() => import('./Globepin2')),
    'globepin-3': lazy(() => import('./Globepin3')),
    google: lazy(() => import('./Google')),
    'hand-pointing-down': lazy(() => import('./HandPointingDown')),
    'hand-pointing-left': lazy(() => import('./HandPointingLeft')),
    'hand-pointing-right': lazy(() => import('./HandPointingRight')),
    'hand-pointing-up': lazy(() => import('./HandPointingUp')),
    handshake: lazy(() => import('./Handshake')),
    headphones: lazy(() => import('./Headphones')),
    'heart-hand-give': lazy(() => import('./HeartHandGive')),
    'heart-line': lazy(() => import('./HeartLine')),
    history: lazy(() => import('./History')),
    'hold-house': lazy(() => import('./HoldHouse')),
    'home-1': lazy(() => import('./Home1')),
    'home-2': lazy(() => import('./Home2')),
    horserider: lazy(() => import('./Horserider')),
    'hospital-shield': lazy(() => import('./HospitalShield')),
    hospital: lazy(() => import('./Hospital')),
    'house-alarm': lazy(() => import('./HouseAlarm')),
    icons: lazy(() => import('./Icons')),
    'id-card': lazy(() => import('./IdCard')),
    'info-circle': lazy(() => import('./InfoCircle')),
    inspection: lazy(() => import('./Inspection')),
    instagram: lazy(() => import('./Instagram')),
    'invoice-changes': lazy(() => import('./InvoiceChanges')),
    'invoice-question': lazy(() => import('./InvoiceQuestion')),
    'invoice-warning': lazy(() => import('./InvoiceWarning')),
    invoice: lazy(() => import('./Invoice')),
    'kilogram-weight': lazy(() => import('./KilogramWeight')),
    ladder: lazy(() => import('./Ladder')),
    'light-bulb': lazy(() => import('./LightBulb')),
    linkedin: lazy(() => import('./Linkedin')),
    locked: lazy(() => import('./Locked')),
    logout: lazy(() => import('./Logout')),
    luggage: lazy(() => import('./Luggage')),
    mail: lazy(() => import('./Mail')),
    meal: lazy(() => import('./Meal')),
    'medical-personel': lazy(() => import('./MedicalPersonel')),
    'medical-symbol': lazy(() => import('./MedicalSymbol')),
    'menu-lines': lazy(() => import('./MenuLines')),
    'messages-bubble': lazy(() => import('./MessagesBubble')),
    'mobile-phone': lazy(() => import('./MobilePhone')),
    mobile: lazy(() => import('./Mobile')),
    'money-back': lazy(() => import('./MoneyBack')),
    money: lazy(() => import('./Money')),
    motorcycle: lazy(() => import('./Motorcycle')),
    news: lazy(() => import('./News')),
    'notes-check': lazy(() => import('./NotesCheck')),
    organization: lazy(() => import('./Organization')),
    'patient-in-bed': lazy(() => import('./PatientInBed')),
    'patient-transport': lazy(() => import('./PatientTransport')),
    'people-check': lazy(() => import('./PeopleCheck')),
    'people-medical': lazy(() => import('./PeopleMedical')),
    'performance-decrease': lazy(() => import('./PerformanceDecrease')),
    'performance-increase': lazy(() => import('./PerformanceIncrease')),
    'periodic-vehicle-inspection': lazy(() => import('./PeriodicVehicleInspection')),
    person: lazy(() => import('./Person')),
    'phone-check': lazy(() => import('./PhoneCheck')),
    phone: lazy(() => import('./Phone')),
    'piggy-bank': lazy(() => import('./PiggyBank')),
    'pin-bold': lazy(() => import('./PinBold')),
    'pin-light': lazy(() => import('./PinLight')),
    'portfolio-business': lazy(() => import('./PortfolioBusiness')),
    presenting: lazy(() => import('./Presenting')),
    'question-circle': lazy(() => import('./QuestionCircle')),
    'quote-1': lazy(() => import('./Quote1')),
    'quote-2': lazy(() => import('./Quote2')),
    rehabilitation: lazy(() => import('./Rehabilitation')),
    revolving: lazy(() => import('./Revolving')),
    'road-warning-triangle': lazy(() => import('./RoadWarningTriangle')),
    room: lazy(() => import('./Room')),
    safe: lazy(() => import('./Safe')),
    'safety-extinguish-fire': lazy(() => import('./SafetyExtinguishFire')),
    'safety-float': lazy(() => import('./SafetyFloat')),
    'save-and-close': lazy(() => import('./SaveAndClose')),
    save: lazy(() => import('./Save')),
    scissors: lazy(() => import('./Scissors')),
    search: lazy(() => import('./Search')),
    'server-lock': lazy(() => import('./ServerLock')),
    settings: lazy(() => import('./Settings')),
    'shield-checkmark': lazy(() => import('./ShieldCheckmark')),
    'shipment-box': lazy(() => import('./ShipmentBox')),
    'shipment-truck': lazy(() => import('./ShipmentTruck')),
    'sign-out': lazy(() => import('./SignOut')),
    'smoke-detector': lazy(() => import('./SmokeDetector')),
    'special-boxes': lazy(() => import('./SpecialBoxes')),
    star: lazy(() => import('./Star')),
    stopwatch: lazy(() => import('./Stopwatch')),
    stretcher: lazy(() => import('./Stretcher')),
    subscription: lazy(() => import('./Subscription')),
    suitcase: lazy(() => import('./Suitcase')),
    tankfarm: lazy(() => import('./Tankfarm')),
    target: lazy(() => import('./Target')),
    team: lazy(() => import('./Team')),
    telephone: lazy(() => import('./Telephone')),
    'ten-percent-wrench': lazy(() => import('./TenPercentWrench')),
    'thumbs-up-1': lazy(() => import('./ThumbsUp1')),
    'thumbs-up-2': lazy(() => import('./ThumbsUp2')),
    'tire-repair': lazy(() => import('./TireRepair')),
    'tools-check': lazy(() => import('./ToolsCheck')),
    touch: lazy(() => import('./Touch')),
    'tow-truck': lazy(() => import('./TowTruck')),
    tractor: lazy(() => import('./Tractor')),
    trailer: lazy(() => import('./Trailer')),
    'trip-road': lazy(() => import('./TripRoad')),
    unlocked: lazy(() => import('./Unlocked')),
    unsubscribe: lazy(() => import('./Unsubscribe')),
    upgrade: lazy(() => import('./Upgrade')),
    'user-question': lazy(() => import('./UserQuestion')),
    user: lazy(() => import('./User')),
    'warning-circle': lazy(() => import('./WarningCircle')),
    'warning-triangle': lazy(() => import('./WarningTriangle')),
    'wheel-under-roof': lazy(() => import('./WheelUnderRoof')),
    wifi: lazy(() => import('./Wifi')),
    'windshield-washer-fluid': lazy(() => import('./WindshieldWasherFluid')),
    'wrench-and-screws': lazy(() => import('./WrenchAndScrews')),
    x: lazy(() => import('./X')),
    'yoga-stretch': lazy(() => import('./YogaStretch')),
    'youtube-1': lazy(() => import('./Youtube1')),
    'youtube-2': lazy(() => import('./Youtube2')),
};

export default svgIconMap;
